import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';


import { User, UserConfig } from './user';
import { ApiService } from '../common/services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { CustomizerService } from '../common/services/customizer.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<User>;
    public currentUser: Observable<User>;
    public config: any;
    private currentUserConfigSubject: BehaviorSubject<UserConfig>;
    public currentUserConfig: Observable<UserConfig>;

    constructor(private http: HttpClient,
                private apiService: ApiService,
                private translate: TranslateService,
                public customize: CustomizerService) {

        this.initUser();
    }

    public next(user) {
        this.currentUserSubject.next(user);
    }

    public get User(): User {
        return this.currentUserSubject.value;
    }

    public initUser() {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();

        this.currentUserConfigSubject = new BehaviorSubject<UserConfig>(JSON.parse(localStorage.getItem('currentUserConfig')));
        this.currentUserConfig = this.currentUserConfigSubject.asObservable();
    }

    public get Config(): UserConfig {
        return this.currentUserConfigSubject.value;
    }

    login(username: string, password: string, authcode: string) {
        //return this.http.post<any>(`${environment.apiUrl}/users/authenticate`, { username, password })
        var endPoint = "DxToken";
        var userData = "username=" + username + "&password=" + password + "&grant_type=password";
        if (authcode) endPoint = "DxExtToken";

        var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'No-Auth': 'True' });

        return this.http.post<any>(endPoint, userData, { headers: reqHeader })
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //localStorage.setItem('currentUser', JSON.stringify(user));
              
                this.currentUserSubject.next(user);

                this.getUserConfig();

                if (this.translate.currentLang == 'ar') {
                    this.customize.setLayoutType('rtl')
                }
                else {
                    this.customize.setLayoutType('ltr')
                }

                return user;
            }));
    }

    getUserConfig() {
        var language = 1;
        if (this.translate.currentLang == 'ar')
            language = 2;
        else if (this.translate.currentLang == 'fr')
            language = 3;

        this.apiService.get("Api/User/Config?language=" + language, "").subscribe((userConfig: any) => {
            this.config = userConfig;
            this.currentUserConfigSubject.next(userConfig);            
            return userConfig;
        });
    }

    logout() {
        // remove user from local storage to log user out
        this.config = null;
        localStorage.removeItem('currentUser');
        localStorage.removeItem('currentUserConfig');
        this.currentUserSubject.next(null);
        this.currentUserConfigSubject.next(null);
    }
}